"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
function createSteps(stepCount, selectedStep, startNumber) {
    if (startNumber === void 0) { startNumber = 1; }
    var arrayOfNumbers = Array.from(Array(stepCount), function (_, x) { return x; }).map(function (n) { return Number(n + startNumber); });
    var result = arrayOfNumbers.reduce(function (acc, n) {
        var _a, _b;
        if (n === selectedStep) {
            return tslib_1.__assign(tslib_1.__assign({}, acc), (_a = {}, _a["step" + selectedStep] = {
                isComplete: false,
                isEdit: true
            }, _a));
        }
        return tslib_1.__assign(tslib_1.__assign({}, acc), (_b = {}, _b["step" + n] = {
            isComplete: false,
            isEdit: false
        }, _b));
    }, {});
    return result;
}
exports.createSteps = createSteps;
//# sourceMappingURL=createSteps.js.map